import React from 'react'

import { CopyableStateReducer, initialState, Actions } from './reducer'
import { useAppDispatch } from '../../hooks/redux'
import { AddSuccessAlert } from '../../slices/alert'

const CopyableStateContext = React.createContext(null)

const SUCCESS_DURATION = 4000

const CopyableStateProvider = ({ children }) => {
  const reduxDispatch = useAppDispatch()
  const [state, dispatch] = React.useReducer(CopyableStateReducer, initialState)

  // Files are not supported with text, so disabling this for now
  const addFile = React.useCallback((id, file, downloaded = false) => {
    // dispatch({ type: Actions.UPDATE_FILE, id, file, downloaded })
  }, [])

  const copyToClipboard = React.useCallback(async () => {
    dispatch({ type: Actions.START_COPY })
  }, [])

  const setText = React.useCallback(text => {
    dispatch({ type: Actions.SET_TEXT, text })
  }, [])

  // Copies text to clipboard
  React.useEffect(() => {
    if (!state.copyReady) {
      return
    }

    dispatch({ type: Actions.FINISH_COPY })

    // Copy text to clipboard
    ;(async () => {
      try {
        await navigator.clipboard.writeText(state.text)
        reduxDispatch(
          AddSuccessAlert('Copied to clipboard.', SUCCESS_DURATION * 1.1)
        )
      } catch (err) {
        console.error('Error copying text', err)
      }
    })()
  }, [state, reduxDispatch])

  return (
    <CopyableStateContext.Provider
      value={{ setText, addFile, copyToClipboard }}
    >
      {children}
    </CopyableStateContext.Provider>
  )
}

export default CopyableStateProvider

export const useCopyableState = () => React.useContext(CopyableStateContext)
